import { Type } from "class-transformer";
import ResponseEntity, { InputEntity } from "../../..";
import { IsArray, IsInt, IsString, ValidateNested } from "class-validator";
import TransmedFormField from "./field";

export default class TransmedFormSubsection extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsString() public readonly title!: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedFormField)
  public readonly fields!: TransmedFormField[];
}

export class TransmedFormSubsectionInput extends InputEntity {
  public constructor(
    public readonly title: string,
    public readonly section: number
  ) {
    super();
  }
}
